const filter = () => {
    const filter = document.querySelectorAll('.news-page__filter');
    if(filter) {
        filter.forEach(i => {
            i.addEventListener('click', (e)=> {
                if(e.target === i) {
                    i.classList.add('news-page__filter_active')
                }
            })
            i.children[0].addEventListener('click', () => {
                i.classList.remove('news-page__filter_active');
            })
        })
    }
}

export default filter;